const CUSTOMER_CARE_ADDRESS = 'https://www.elliottwave.com/about/customer-care';
const WWW_Address = 'https://www.elliottwave.com/';
const MY_EWI_ADDRESS = 'https://my.elliottwave.com/';
const LOGIN_ADDRESS = 'https://account.elliottwave.com/?reurl=https://my.elliottwave.com';
const PROFILE_ADDRESS = 'https://profile.elliottwave.com';
const CART_COOKIE = 'EWICart';
const SITE_TOKEN_COOKIE = "EWISiteToken2";
const CACHE_BUSTER_COOKIE = "wordpress_nocache";
const ID_COOKIE = 'ewiUserId';
const COOKIE_DOMAIN = '.elliottwave.com';

let STORE_ADDRESS;

//This is mainly for testing purposes. Revisit this later.
if (process.env.NODE_ENV === 'development') {
  // STORE_ADDRESS = 'https://localhost:7200';
  STORE_ADDRESS = 'https://store.elliottwave.com';
} else {
  STORE_ADDRESS = 'https://store.elliottwave.com';
}



export { STORE_ADDRESS, CUSTOMER_CARE_ADDRESS, MY_EWI_ADDRESS, CART_COOKIE, COOKIE_DOMAIN, ID_COOKIE, SITE_TOKEN_COOKIE, CACHE_BUSTER_COOKIE, LOGIN_ADDRESS, PROFILE_ADDRESS, WWW_Address };